export default __webpack_public_path__ + "static/media/mr_mrs_smith_background_s1.2b2841d1.jpg";